
import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import {useTranslation} from "react-i18next";
import {CART_NOTIFICATION} from "../../../locales/components/namespaces";



export default function OrderSummaryTop({ orderHeader }) {
    const {t} = useTranslation(CART_NOTIFICATION);
    const ORDER_TITLE = "Επιβεβαίωση παραγγελίας";
    const CONFIRMATION_MESSAGE =
        "Η παραγγελία σας έχει καταχωρηθεί με επιτυχία. Σύντομα θα λάβετε σχετικά email για την εξέλιξή της.";
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Box>
                <Typography
                    sx={{
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontWeight: 900,
                        fontSize: { xs: 32, md: 48 },
                        lineHeight: "90%",
                        textTransform: "uppercase",
                        color: "#111111",
                        mb: 2,
                    }}
                >
                    {ORDER_TITLE}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontSize: 16,
                        lineHeight: "120%",
                        color: "#111111",
                        maxWidth: 500,
                    }}
                >
                    {CONFIRMATION_MESSAGE}
                </Typography>
            </Box>

            <Box sx={{ maxWidth: 920, display: "flex", flexDirection: "column", gap: 2 }}>

                <Box
                    sx={{
                        display: { xs: "none", md: "flex" },
                        justifyContent: "space-between",
                        px: 2,
                    }}
                >
                    {[t("Order Number"), t("Date"), t("Total"), t("Payment Method")].map(
                        (label) => (
                            <Typography
                                key={label}
                                sx={{
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    fontWeight: 700,
                                    fontSize: 14,
                                    textTransform: "uppercase",
                                    width: "25%",
                                }}
                            >
                                {label}
                            </Typography>
                        )
                    )}
                </Box>
                <Paper
                    sx={{
                        backgroundColor: "#E9E9E9",
                        borderRadius: "10px",
                        px: 2.5,
                        py: 1.5,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            rowGap: 2,
                            mt: 1,
                        }}
                    >
                        {[
                            { label: t("Order Number"), value: orderHeader.orderNumber },
                            { label: t("Date"), value: orderHeader.orderDate },
                            { label: t("Total"), value: orderHeader.orderTotal },
                            { label: t("Payment Method"), value: orderHeader.paymentMethod },
                        ].map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width: { xs: "50%", sm: "25%" },
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.3,
                                }}
                            >
                                <Typography
                                    sx={{
                                        display: { xs: "block", md: "none" },
                                        fontFamily: "'Roboto Condensed', sans-serif",
                                        fontWeight: 700,
                                        fontSize: 11,
                                        textTransform: "uppercase",
                                        color: "#555",
                                        lineHeight: 1.1,
                                    }}
                                >
                                    {item.label}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontFamily: "'Roboto Condensed', sans-serif",
                                        fontSize: 14,
                                        lineHeight: "120%",
                                        color: "#101010",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {item.value}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                </Paper>
            </Box>
        </Box>
    );
}
